<template>
  <div class="bg-gray-900 text-white min-h-screen">
    <NavigationBar />
    <router-view/>
    <FooterBar></FooterBar>
  </div>
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Amita:wght@400;700&display=swap');
.router-link-active{
  @apply text-orange-500;
  @apply font-bold
}
.logo-title{
  font-family: 'Amita', cursive;
  font-weight: bold;
}
//.section-tile{
//  font-family: 'Amita', cursive;
//  font-weight: bold;
//}
</style>
<script>
import NavigationBar from "@/components/NavigationBar";
import FooterBar from "@/components/FooterBar";
export default {
  components: {FooterBar, NavigationBar},
}
</script>